import { jsx as e } from "react/jsx-runtime";
//#region src/components/assets/Asset.tsx
var t = ({ source: { Artwork: t, width: n, height: r }, ...i }) => /* @__PURE__ */ e(t, {
	width: n,
	height: r,
	...i
});
//#endregion
export { t as Asset };
